export const defaultTaxonomy = [
  { label: 'News', children: ['Local News', 'Crime', 'Education', 'Court'] },
  { label: 'Politics', children: ['Local Politics', 'World Politics', 'Elections', 'Policy'] },
  { label: 'Opinion', children: [] },
  { label: 'Business', children: ['Economy', 'Finance', 'Industry News', 'Real Estate'] },
  { label: 'Entertainment', children: ['Celebrities', 'Movies', 'Music', 'SceneCity', 'Cracks', 'TSZ Mzansi', 'Awards'] },
  { label: 'Lifestyle', children: ['Fashion', 'Beauty', 'Money', 'Wellness', 'Food', 'Travel', 'Dating', 'Parenting'] },
  { label: 'Technology', children: ['Fintech', 'AI', 'Big Tech', 'Social Media', 'Gaming', 'Startups', 'Science'] },
  { label: 'Sports', children: ['Rugby', 'Cricket', 'Football', 'Tennis'] },
  { label: 'Games', children: [] },
  { label: 'Roundup', children: [] }
];
